export const BASIC_VIEW = 0
export const QUICK_VIEW = 1
export const FULL_VIEW = 2
